import { useParams } from "react-router-dom";
import { MediaItemIndexScreen } from "../../resources/MediaItemIndexScreen";

export const ResourcesIndexScreen: React.FC<any> = () => {
  const { assignmentId } = useParams();
  return <MediaItemIndexScreen subjectId={assignmentId} />;
};
